// external
import React, { FC } from 'react';

// internal
import './settings.page.css';
import COEHeaderComponent from '../../components/coe-header/coe-header.component';
import PersonalInfoPage from './pages/personal-info.page';
import GuardianManagementPage from './pages/guardian-management.page';
import MyDashboardPage from './pages/my-dashboard.page';

interface SettingsPageProps {
  tab?: 'guardian-management' | 'account';
}

const SettingsPage: FC<SettingsPageProps> = (props) => {
  const renderRoute = () => {
    if (props.tab === 'guardian-management') {
      return <GuardianManagementPage />;
    }
    if (props.tab === 'account') {
      return <PersonalInfoPage />;
    }
    return <MyDashboardPage />;
  };

  return (
    <div className={window.localStorage.getItem('sidedrawer') ? 'page-full' : 'page'} id="page">
      <COEHeaderComponent
        title="Profile"
        tabs={[
          { label: 'My Dashboard', value: '/profile' },
          { label: 'Account', value: '/profile/account' },
          { label: 'Guardians', value: '/profile/guardian-management' },
        ]}
      />
      <div className="settings-page">{renderRoute()}</div>
    </div>
  );
};

export default SettingsPage;
